







import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ImageCaption',
  props: { blok: { type: Object } },
});
